var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",style:(_vm.btnStyle),attrs:{"disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(!_vm.loading)?_vm._t("default"):_vm._e(),(_vm.loading)?_c('pulse-loader',{attrs:{"size":_vm.loadingSize + 'px',"color":_vm.loadingColor}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }